import { useQuery } from '@tanstack/react-query';
import { exteriorSelect, interiorSelect, modelsSelect, variantsSelect, vehiclesSelect } from '../modules/pages/components/dummyData';
import { generalGet } from '../API/api';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const models: Record<string, any> = {
  exterior_colors: {
    labelKey: 'label',
    valueKey: 'value',
    route: 'select/exterior-colors-select',
    dummyObject: exteriorSelect
  },
  interior_colors: {
    labelKey: 'label',
    valueKey: 'value',
    route: 'select/interior-colors-select',
    dummyObject: interiorSelect
  },
  models: {
    labelKey: 'label',
    valueKey: 'value',
    route: 'select/models-select',
    dummyObject: modelsSelect
  },
  variants: {
    labelKey: 'label',
    valueKey: 'value',
    route: 'select/variants-select',
    dummyObject: variantsSelect
  },
  vehicles: {
    labelKey: 'label',
    valueKey: 'value',
    route: 'select/vehicles-select',
    dummyObject: vehiclesSelect
  }
};

export default function useSectionModelsData(selectedModel: string) {
  const { t } = useTranslation();
  const dataTypesOptions = useMemo(
    () => [
      { label: t('exterior_colors'), value: 'exterior_colors' },
      { label: t('interior_colors'), value: 'interior_colors' },
      { label: t('models'), value: 'models' },
      { label: t('variants'), value: 'variants' },
      { label: t('vehicles'), value: 'vehicles' }
    ],
    []
  );

  const { data, isLoading } = useQuery({
    queryKey: ['section-data', selectedModel],
    queryFn: () => generalGet(selectedModel ? models[selectedModel].route : ''),
    enabled: !!selectedModel
  });

  const selectOptions = useMemo(() => {
    if (!data && !selectedModel) return [];
    const dataObj = data?.data || models[selectedModel]?.dummyObject;
    const dataArr = Array.isArray(dataObj) ? dataObj : Object.values(dataObj)?.flatMap((value) => value);
    return (dataArr as any)
      ?.map((ele: any) => {
        const label = ele[models[selectedModel].labelKey];
        const value = ele[models[selectedModel].valueKey];
        if (!value) return null;
        return {
          label,
          value
        };
      })
      .filter((ele: any) => ele);
  }, [data, selectedModel]);

  return {
    selectOptions,
    dataTypesOptions,
    isLoading
  };
}
